import { createSlice } from "@reduxjs/toolkit";
import addTeleModPrice from "../../../rtk-apis/Setting/addTeleModPrice";

const initialState = {
    status: "",
    result: {},
    msg: "",
    loading: false,
    error: ""
};

const addTeleModPriceSlice = createSlice({
    name: "addTeleModPriceSlice",
    initialState,
    reducers: {
        clearAddTeleModPriceState: (state: any) => {
            state.status = '';
            state.result = {};
            state.msg = '';
            state.loading = false;
            state.error = '';
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(addTeleModPrice.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(addTeleModPrice.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.status = payload.status;
                state.result = payload.data;
                state.msg = payload.msg;
            })
            .addCase(addTeleModPrice.rejected, (state, { payload }) => {
                state.result = payload;
                state.loading = false;
                state.status = 'FAILED';
                state.error = payload?.msg;
            });
    },
});

export default addTeleModPriceSlice.reducer;
export const { clearAddTeleModPriceState } = addTeleModPriceSlice.actions;
